import { render, staticRenderFns } from "./CollapsableContainer.vue?vue&type=template&id=c6510548&scoped=true"
import script from "./CollapsableContainer.vue?vue&type=script&lang=js"
export * from "./CollapsableContainer.vue?vue&type=script&lang=js"
import style0 from "./CollapsableContainer.vue?vue&type=style&index=0&id=c6510548&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6510548",
  null
  
)

export default component.exports